import {
  toDataSourceRequestString,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";

class PersonelService {
  getList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/personel/get-list`)
      .then((response) => {
        return response.data;
      });
  }

  getGuestPICList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/personel/get-guest-pic-list`)
      .then((response) => {
        return response.data;
      });
  }

  getFilterList(dataState, callback) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/personel/get-list-by-filter?${toDataSourceRequestString(dataState)}`
      )
      .then((response) => {
        if (callback) callback(response.data);
        return dataState.group && dataState.group.length
          ? translateDataSourceResultGroups(response.data)
          : { data: response.data, dataState };
      });
  }
}

export default new PersonelService();
